import React from 'react';

const Snowflakes = () => {
  return (
    <>
      {Array.from({ length: 20 }).map((_, i) => (
        <div key={i} className="snowflake">❄</div>
      ))}
    </>
  );
};

export default Snowflakes;